// Libraries
import _ from 'lodash';

// Supermove
import {gql} from '@supermove/graphql';
import {withFragment} from '@supermove/utils';

// App
import SurveyMethodKind from '@shared/modules/Inventory/enums/SurveyMethodKind';

const getDisplayKind = withFragment(
  (inventory) => {
    switch ((inventory as any).kind) {
      case 'NONE':
        return '';
      case 'ONLINE':
        return 'Online';
      case 'PHONE':
        return 'Phone';
      case 'CUSTOMER_SUBMITTED':
        return 'Customer Submitted';
      case 'IN_HOME_ESTIMATE':
        return 'In-Person Estimate';
      case 'VIRTUAL_WALKTHROUGH':
        return 'Virtual Walkthrough';
      default:
        return '';
    }
  },
  gql`
    fragment Inventory_getDisplayKind on Inventory {
      kind
    }
  `,
);

const getIsVirtualWalkthrough = withFragment(
  (inventory) => {
    if ((inventory as any).surveyMethod) {
      return (inventory as any).surveyMethod.kind === SurveyMethodKind.VIRTUAL_WALKTHROUGH;
    }
    return (inventory as any).kind === SurveyMethodKind.VIRTUAL_WALKTHROUGH;
  },
  gql`
    fragment Inventory_getIsVirtualWalkthrough on Inventory {
      id
      kind
      surveyMethod {
        id
        kind
      }
    }
  `,
);

const getIsNoSurvey = withFragment(
  (inventory) => {
    if ((inventory as any).kind === 'CUSTOMER_SUBMITTED') {
      return false;
    }
    if ((inventory as any).surveyMethod) {
      return (inventory as any).surveyMethod.kind === SurveyMethodKind.NO_SURVEY;
    }
    return (inventory as any).kind === 'NONE';
  },
  gql`
    fragment Inventory_getIsNoSurvey on Inventory {
      id
      kind
      surveyMethod {
        id
        kind
      }
    }
  `,
);

const getMatches = (string: any, regex: any) => {
  return _.toString(string).match(regex) || [];
};

const formatNumberValue = (value: any) => {
  if (value === '') {
    return 0;
  }

  const numerics = getMatches(value, /[.]?\d+[.\d+]?/g).join('');
  const alpha = getMatches(value, /[a-zA-Z]+/g)
    .join('')
    .toLowerCase();

  if (alpha.length > 0) {
    return 0;
  }

  return parseFloat(numerics);
};

const getFloatValue = (value: any) => {
  return formatNumberValue(value);
};

const containsOnlyDigits = (value: any) => {
  const digitsRegex = /^\d+$/;

  return digitsRegex.test(value);
};

const COLOR_OPTIONS = {
  Purple: '#9B51E0',
  Blue: '#34ACE0',
  Green: '#27AE60',
  Yellow: '#F1C40F',
  Orange: '#F2A12C',
  Red: '#E74C3C',
  Pink: '#E84393',
  Grey: '#616161',
  Black: '#000000',
  White: '#FFFFFF',
};

const getColorOptions = () =>
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  Object.keys(COLOR_OPTIONS).map((key) => ({label: key, value: COLOR_OPTIONS[key]}));

const getColorNameFromHex = (hex: any) => {
  const colorName = _.findKey(COLOR_OPTIONS, (value) => value === hex);
  return colorName || '';
};

const getColorHexFromName = (color: any) => {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return COLOR_OPTIONS[color] || '';
};

const Inventory = {
  getDisplayKind,
  getIsVirtualWalkthrough,
  getIsNoSurvey,
  getFloatValue,
  containsOnlyDigits,
  getColorOptions,
  getColorNameFromHex,
  getColorHexFromName,
};

export default Inventory;
